import React, { lazy, memo } from 'react';
export const TestimonialsSection = memo(function TestimonialsSection() {
  const testimonials = [{
    name: 'Nicolás R.',
    location: 'Córdoba',
    time: '11:42',
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    message: 'Loco, compré el pack sin saber nada y en una semana ya estaba cambiando tomacorrientes solo. Lo que me iba a cobrar el técnico me lo ahorré el primer día 😂🙌'
  }, {
    name: 'Martín G.',
    location: 'Buenos Aires',
    time: '09:15',
    avatar: 'https://randomuser.me/api/portraits/men/45.jpg',
    message: 'Laburaba de repositor y no llegaba a fin de mes. Con los tomos en 3 semanas hice mi primer tablero y cobré lo que ganaba en 10 días de depósito. Cambió todo 🔥'
  }, {
    name: 'Diego F.',
    location: 'Rosario',
    time: '20:33',
    avatar: 'https://randomuser.me/api/portraits/men/67.jpg',
    message: 'Ya laburaba de elec pero los tableros complejos los esquivaba. El tomo 6 me abrió la cabeza. Subí los precios un 60% y los clientes no paran de llamar 💪'
  }, {
    name: 'Sebastián M.',
    location: 'Mendoza',
    time: '14:20',
    avatar: 'https://randomuser.me/api/portraits/men/22.jpg',
    message: 'Con el checklist del bono 3 encontré 4 riesgos en mi casa que ni sabía que tenía jaja. Arreglé todo yo mismo, mi señora quedó con la boca abierta 😂 Vale cada peso.'
  }, {
    name: 'Lucas P.',
    location: 'La Plata',
    time: '17:55',
    avatar: 'https://randomuser.me/api/portraits/men/54.jpg',
    message: 'Nunca había comprado algo digital, dudé mil veces. Pero con la garantía me tiré. Ni loco pido devolución, recuperé la plata en la primera semana 🙏'
  }, {
    name: 'Facundo T.',
    location: 'Santa Fe',
    time: '08:47',
    avatar: 'https://randomuser.me/api/portraits/men/78.jpg',
    message: 'Estudio ingeniería y la normativa AEA explicada así no la vi en ningún lado. Se lo mandé a 3 compañeros y los tres lo compraron jaja. Un caño 🤙'
  }];
  return <section className="py-16 bg-gray-900 border-t border-gray-800 overflow-hidden" data-id="element-233">
      {/* Header */}
      <div className="text-center px-4 mb-6" data-id="element-234">
        <div className="inline-block bg-green-500/10 text-green-400 px-5 py-1.5 rounded-full font-black text-[11px] uppercase tracking-widest mb-4 border border-green-500/20" data-id="element-235">
          ✅ LO QUE DICEN LOS QUE YA LO TIENEN
        </div>
        <h2 className="text-[24px] md:text-4xl font-black text-white leading-tight" data-id="element-236">
          Resultados reales de personas{' '}
          <span className="text-blue-500" data-id="element-237">como vos:</span>
        </h2>
        {/* Aclaración */}
        <p className="text-gray-500 text-[11px] mt-3 max-w-sm mx-auto" data-id="element-238">
          * Los testimonios reflejan experiencias individuales. Los resultados
          pueden variar según el nivel de dedicación de cada persona.
        </p>
      </div>

      {/* Hint deslizar mobile */}
      <div className="flex items-center justify-center gap-2 mb-4 md:hidden" data-id="element-239">
        <span className="text-gray-500 text-[11px]" data-id="element-240">
          👈 Deslizá para ver más
        </span>
      </div>

      {/* Carrusel deslizable con el dedo */}
      <div className="relative w-full" data-id="element-241">
        {/* Fade izquierda */}
        <div className="absolute left-0 top-0 bottom-0 w-8 md:w-16 bg-gradient-to-r from-gray-900 to-transparent z-10 pointer-events-none" data-id="element-242" />
        {/* Fade derecha */}
        <div className="absolute right-0 top-0 bottom-0 w-8 md:w-16 bg-gradient-to-l from-gray-900 to-transparent z-10 pointer-events-none" data-id="element-243" />

        <div className="flex gap-4 px-4 py-2 overflow-x-auto scroll-smooth" style={{
        scrollSnapType: 'x mandatory',
        WebkitOverflowScrolling: 'touch',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
      }} data-id="element-244">
          <style data-id="element-245">{`
            div::-webkit-scrollbar { display: none; }
          `}</style>

          {testimonials.map((t, index) => <div key={index} className="flex-shrink-0 w-[270px] bg-[#111B21] rounded-2xl overflow-hidden border border-gray-800 shadow-lg" style={{
          scrollSnapAlign: 'start'
        }} data-id="element-246">
              {/* Header WhatsApp */}
              <div className="bg-[#202C33] px-3 py-2.5 flex items-center gap-2.5" data-id="element-247">
                <img src={t.avatar} alt={t.name} loading="lazy" decoding="async" className="w-8 h-8 rounded-full object-cover flex-shrink-0" data-id="element-248" />
                <div className="flex-1 min-w-0" data-id="element-249">
                  <p className="text-white font-bold text-[12px] leading-tight" data-id="element-250">
                    {t.name}
                  </p>
                  <p className="text-gray-400 text-[10px]" data-id="element-251">📍 {t.location}</p>
                </div>
                <span className="text-gray-500 text-[10px]" data-id="element-252">{t.time}</span>
              </div>

              {/* Mensaje */}
              <div className="bg-[#0B141A] p-3" data-id="element-253">
                <div className="flex justify-end" data-id="element-254">
                  <div className="bg-[#005C4B] text-white text-[12px] leading-relaxed px-3 py-2 rounded-xl rounded-tr-sm max-w-[95%] shadow-sm" data-id="element-255">
                    {t.message}
                    <div className="flex items-center justify-end gap-1 mt-1" data-id="element-256">
                      <span className="text-[10px] text-green-300/60" data-id="element-257">
                        {t.time}
                      </span>
                      <svg className="w-3 h-3 text-blue-400" viewBox="0 0 16 11" fill="currentColor" data-id="element-258">
                        <path d="M11.071.653a.5.5 0 0 0-.707 0L4.54 6.477 2.121 4.059a.5.5 0 0 0-.707.707l2.772 2.772a.5.5 0 0 0 .707 0l6.178-6.178a.5.5 0 0 0 0-.707zM14.071.653a.5.5 0 0 0-.707 0L7.54 6.477l-.354-.353-.707.707.707.707a.5.5 0 0 0 .707 0l6.178-6.178a.5.5 0 0 0 0-.707z" data-id="element-259" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
});